// extracted by mini-css-extract-plugin
export default {"selection":"ManageSelection_selection__eTzm4nsq","countSelected":"ManageSelection_countSelected__p6HlOMTu"};